import {SensorModeType} from '../enums/sensor-mode-type';

export class SensorModel {
  pairMode?: SensorModeType;
  type?: string;
}
